import React, { useEffect, useState } from "react";

import { addCreditForecast, deleteCreditForecast, getAllCreditForecasts, updateCreditForecasts } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminSection, Button, Col, Form, InputNumber, MainPage, Row } from "components";

export const CreditForcasts = () => {
  const signal = useCancelAsyncOnUnmount()();

  const [loading, setLoading] = useState(true);
  const [creditForecasts, setCreditForecasts] = useState(null);

  const loadCreditForecasts = () => {
    setLoading(true);
    getAllCreditForecasts({
      signal,
    })
      .then((res) => {
        setCreditForecasts(res.sort((a, b) => a.year - b.year));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteYear = (id) => {
    setLoading(true);
    deleteCreditForecast({
      forecastId: id,
      signal,
    }).finally(() => {
      loadCreditForecasts();
    });
  };

  const addYear = (v) => {
    setLoading(true);
    addCreditForecast({
      ...v,
      signal,
    }).finally(() => {
      loadCreditForecasts();
    });
  };

  const updateYears = (v) => {
    updateCreditForecasts({
      ...v,
      signal,
    }).finally(() => {
      loadCreditForecasts();
    });
  };
  const incomplete = () => {};

  useEffect(() => {
    loadCreditForecasts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Update Credit Sales Forecasts"
        description="This page displays the sales forecast for the upcoming years and provides the sales team with the ability to add, update or delete forecasted years using the form below."
        link={"/partners/predictions"}
        tooltipText={"Back to predictions"}
      />
      <>
        {creditForecasts && (
          <>
            <Row>
              <Col>
                <Form className="midi-form" name="confirm" onFinish={(v) => updateYears(v)} onFinishFailed={(v) => incomplete(v)}>
                  <AdminSection headline="Credit Forecasts" />

                  {creditForecasts.map((forecast) => (
                    <Row key={forecast.id}>
                      <Col md={20}>
                        <InputNumber initialValue={forecast.value} name={forecast.id} label={forecast.year} rules={[{ required: true }]} />
                      </Col>
                      <Col md={4}>
                        <Button type="secondary" onClick={() => deleteYear(forecast.id)} disabled={loading} loading={loading}>
                          Delete year
                        </Button>
                      </Col>
                    </Row>
                  ))}

                  <Row>
                    <Col>
                      <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                          Save all
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <Form className="midi-form" name="confirm" onFinish={(v) => addYear(v)} onFinishFailed={(v) => incomplete(v)}>
                  <AdminSection headline="Add Credit Forecast" />
                  <Row>
                    <Col md={12}>
                      <InputNumber name={"year"} label={"Forecast Year"} rules={[{ required: true }]} />
                    </Col>
                    <Col md={12}>
                      <InputNumber name={"value"} label={"Forecast Value"} rules={[{ required: true }]} />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                          Add
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </>
        )}
      </>
    </MainPage>
  );
};
